const safeEnv = (key, fallback = '') => {
    try {
        if (typeof process !== 'undefined' && process.env && process.env[key]) {
            return process.env[key];
        }
    } catch (e) {}
    return fallback;
};

export const KLAVIYO_PUBLIC_KEY = "ViQ7sq";
export const KLAVIYO_LIST_ID = "WF6tAL";

export const PAGES_API_HOST = safeEnv('NODE_ENV') === 'production'
    ? ""
    : "";

import { getApiHost } from './apiHost.js';
export const PLAYER_ASSET_HOST = getApiHost();

export const DEFAULT_SEASON_ID = '65679';

export const API_HOST = safeEnv('API_HOST') || 'https://www.footballinsider247.com';

export const PRIMARY_COLOR = safeEnv('PRIMARY_COLOR') || '#d4af37';

export const getPlayerAssetUrl = (filename) => {
    return `/player/${filename}`;
};

export const getWorldCupAssetUrl = (filename) => {
    return `/worldcup/${filename}`;
};

export const WC_2026_ARTICLES_TAG = 'worldcup 2026';

export const WC_2026_TITLE = "WORLD CUP 2026";
export const WC_2026_STATS = [
  { label: "MATCHES", value: "64", isLong: false },
  { label: "TEAMS", value: "48", isLong: false },
  { label: "COUNTRY", value: "UNITED STATES / MEXICO / CANADA", isLong: true }
];
